
import { updateProjectFromCanvas } from "./MenuHelpers.js";
import { sort, head, tail, isEmpty, exists, collect, toArray, append, singleton, forAll, filter, empty, ofArray, map, iterate, tryFind } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { designForSidecar, simCacheInit, simCache, startCircuitSimulation } from "../Simulator/Simulator.js";
import { dbg, error as error_1, warn } from "../Shared/Log.js";
import { toText, printf, toFail, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { fastDataZero, Bit, FastData, FastBits, SimulationComponentState, SimulationError, SimulationErrorType, FSInterface, errMsg } from "../Simulator/SimGraphTypes.js";
import { stepRunTarget_, sidecarInFlight_, SimulationProgress, PopupProgress, stimulusGeneration_, SidecarAnswer, SidecarOp, SidecarSessionState__get_Epoch, SidecarSessionState__Holds_Z18115A39, sheet_, Msg, RightTab } from "../Model/ModelType.js";
import { Result_DefaultValue, Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { writeFile, pathJoin } from "../Interface/FilesIO.js";
import { errorPropsNotification, errorNotification, successSimulationNotification, displayAlertOnError } from "./Notifications.js";
import { CompilationProfile, getVerilog } from "../VerilogComponent/Verilog.js";
import { extractStatefulComponents, extractFastSimulationIOs, outputsAreTheSameAsDefault, extractFastSimulationOutput, changeInput } from "../Simulator/FastSim/FastExtract.js";
import { strToIntCheckWidth, fastDataToPaddedString, bitToString, convertBigintToFastData } from "../Simulator/NumberHelpers.js";
import { toFloat64, fromInt64, compare, equals as equals_1, fromUInt32, fromZero } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { map as map_1 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { compareArrays, curry4, uncurry2, safeHash, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { value as value_2, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { BoundingBox, Rotation, XYPos, Memory1, PortType, Component, ComponentType, isClockedPrimitive } from "../Common/CommonTypes.js";
import { fill, forget, PanelSignal, valueAt } from "./StepPanelData.js";
import { cToInt } from "../Common/Ids.js";
import { isEmpty as isEmpty_1, add, toList as toList_1, ofList, FSharpMap__get_Item, FSharpMap__Add, containsKey } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Optic_Get, Optic_Get_op_HatDot_Z146BA564 } from "../Common/Optics.js";
import { DrawModelType_BusWireT_Msg, DrawModelType_SymbolT_Msg, DrawModelType_SymbolT_Annotation, DrawModelType_SheetT_Msg, DrawModelType_SheetT_KeyboardMsg, DrawModelType_SheetT_symbol_, DrawModelType_SymbolT_Model, DrawModelType_SymbolT_Symbol, DrawModelType_SheetT_symbolOf_, DrawModelType_SheetT_symbols_ } from "../Model/DrawModelType.js";
import { map as map_2, empty as empty_1, singleton as singleton_1, append as append_1, delay, toList, forAll as forAll_1 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { right as right_1, item, left as left_1, Level_Option, level } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { SimulatedDesign__get_ExpandedComponentCount, SimulatedDesign__FullNameOf_Z7956074D, FastSimulation__get_SimulatedTopSheet, StepCost__get_TotalBytes, SimulationBudget_formatBytes, SimulatedDesign__InstancesOfComponents_Z5E942382 } from "../Simulator/SimTypes.js";
import { ofInstanceCached } from "../Simulator/FastSim/PortView.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { simulateModel, tryGetLoadedComponents, simReset, newSeq, sidecarIsBusy, Constants_advanceChunkMs, Constants_rendererArraySizeWhenSidecarSimulates, Constants_minStepArraySize, stepSimCycles, designStepCost } from "./ModelHelpers.js";
import { runFastSimulation } from "../Simulator/FastSim/FastRun.js";
import { simReadRam, simSetInputs, transportFailure, logFailure } from "../Interface/SidecarClient.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { build as build_1, errorIn, runChunk } from "../Interface/SidecarSession.js";
import { toMemoryIfSmall, Constants_maxSlotsForWholeRead } from "../Simulator/RamStore.js";
import { updateAllMemoryComps, baseSelector, openMemoryDiffViewer } from "./MemoryEditorView.js";
import { cropToLength } from "../Common/Helpers.js";
import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { simulationNumberStyle, simulationBitStyle } from "./Style.js";
import { Text_span, Common_GenericOption, Modifier_IModifier, TextWeight_Option, Text_p, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_1, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { toString } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { getIntEventValue, getTextEventValue } from "../Interface/JSHelpers.js";
import { HTMLAttr, DOMAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react_1 from "react";
import { dataTooltip } from "../fable_modules/Fulma.Extensions.Wikiki.Tooltip.4.0.0/Tooltip.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { DrawModelType_SheetT_Model__Model_ChangeCounterComp, DrawModelType_SheetT_Model__Model_ChangeAdderComp, isAllVisible } from "../DrawBlock/Sheet.js";
import { getPortPos } from "../DrawBlock/Symbol.js";
import { getPortName } from "../Simulator/CanvasStateAnalyser.js";
import { errorMessage } from "./ErrorDisplay.js";
import { Option as Option_2, h5 } from "../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { Cmd_none, Cmd_OfPromise_either, Cmd_ofEffect, Cmd_batch, Cmd_OfAsyncWith_perform } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getTimeMs } from "../Common/TimeHelpers.js";
import { dialogPopup } from "../DrawBlock/PopupHelpers.js";

export const Constants_maxArraySize = 550;

export const Constants_boxMaxChars = 34;

export const Constants_ncPortDist = 30;

/**
 * Write one sheet, and everything below it, as a Verilog file beside the project.
 * 
 * The sheet is a parameter rather than always the open one, so any sheet can be written from its
 * pill in the sheet menu. Verilog output was already rooted at a single sheet and flattened over
 * its subtree - buildFastSimulation inlines custom components, and getVerilog emits one module
 * called main - so this only makes explicit which sheet is the root.
 * 
 * TODO: the simulation error display here is shared with step simulation and also waveform simulation -
 * maybe it should be a subfunction.
 */
export function verilogOutputForSheet(sheetName, vType, model, dispatch) {
    let tupledArg_1;
    const matchValue = updateProjectFromCanvas(model, dispatch);
    if (matchValue != null) {
        const proj = matchValue;
        if (model.UIState == null) {
            const matchValue_2 = tryFind((lc) => (lc.Name === sheetName), proj.LoadedComponents);
            if (matchValue_2 != null) {
                let _arg;
                const tupledArg = matchValue_2.CanvasState;
                _arg = startCircuitSimulation(2, sheetName, tupledArg[0], tupledArg[1], proj.LoadedComponents);
                if (_arg.tag === 1) {
                    const simError = _arg.fields[0];
                    warn(concat("simulation error prevents Verilog output: ", errMsg(simError.ErrType)));
                    dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Simulation]));
                    if ((simError.InDependency == null) && (sheetName === proj.OpenFileName)) {
                        dispatch((tupledArg_1 = [simError.ComponentsAffected, simError.ConnectionsAffected], new Msg(/* SetHighlighted */ 35, [tupledArg_1[0], tupledArg_1[1]])));
                    }
                    dispatch(new Msg(/* StartSimulation */ 10, [new FSharpResult$2(/* Error */ 1, [simError])]));
                }
                else {
                    const path = pathJoin([proj.ProjectPath, sheetName + ".v"]);
                    displayAlertOnError(dispatch, (() => {
                        try {
                            return writeFile(path, getVerilog(vType, _arg.fields[0].FastSim, CompilationProfile.Release));
                        }
                        catch (e) {
                            error_1(concat("generating Verilog output: ", e.message));
                            return new FSharpResult$2(/* Error */ 1, [e.message]);
                        }
                    })());
                    dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Simulation]));
                    dispatch(new Msg(/* SetSimulationNotification */ 76, [successSimulationNotification(concat("verilog output written to file ", path))]));
                }
            }
            else {
                displayAlertOnError(dispatch, new FSharpResult$2(/* Error */ 1, [concat("Cannot write Verilog: there is no sheet called \'", sheetName, "\' in this project.")]));
            }
        }
    }
}

export function setFastSimInputsToDefault(fs) {
    iterate((tupledArg_1) => {
        changeInput(tupledArg_1[0], new FSInterface(/* IData */ 0, [tupledArg_1[1]]), 0, fs);
    }, map((tupledArg) => {
        const _arg_1 = tupledArg[1];
        const w_1 = _arg_1[1][0] | 0;
        const defaultVal = _arg_1[1][1];
        const cid = _arg_1[0];
        if (defaultVal == null) {
            return [cid, convertBigintToFastData(w_1, fromZero())];
        }
        else {
            return [cid, convertBigintToFastData(w_1, defaultVal)];
        }
    }, ofArray(map_1((fc_1) => {
        let matchValue_1;
        return [fc_1.cId, [fc_1.cId, (matchValue_1 = fc_1.FType, (matchValue_1.tag === 0) ? [matchValue_1.fields[0], matchValue_1.fields[1]] : toFail(printf("What? Impossible")))]];
    }, fs.FCompsByIndex.filter((fc) => {
        if (equals(fc.AccessPath, empty())) {
            if (fc.FType.tag === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    })))));
}

function topComponentsWhere(chosen, fs) {
    let option_1;
    return defaultArg((option_1 = tryFind((ldc) => (ldc.Name === fs.Design.DesignTopSheet), fs.Design.DesignSheets), (option_1 != null) ? filter(chosen, option_1.CanvasState[0]) : undefined), empty());
}

function topRegisters(fs) {
    return topComponentsWhere((comp) => {
        if (isClockedPrimitive(comp.Type)) {
            const matchValue = comp.Type;
            switch (matchValue.tag) {
                case 41:
                case 42:
                case 40:
                    return false;
                default:
                    return true;
            }
        }
        else {
            return false;
        }
    }, fs);
}

function topLevelInputs(fs) {
    return topComponentsWhere((comp) => {
        if (comp.Type.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, fs);
}

function inputValueAt(model, fs, comp, tick) {
    if (model.SimulateInRenderer) {
        const matchValue = extractFastSimulationOutput(fs, tick, comp.Id, empty(), 0);
        if (matchValue.tag === 1) {
            return fromZero();
        }
        else {
            const matchValue_1 = matchValue.fields[0].Dat;
            if (matchValue_1.tag === 1) {
                return matchValue_1.fields[0];
            }
            else {
                return fromUInt32(matchValue_1.fields[0]);
            }
        }
    }
    else {
        return defaultArg(valueAt(tick, new PanelSignal(cToInt(comp.Id), empty(), 0)), fromZero());
    }
}

export function InputDefaultsEqualInputs(fs, model, clocktick) {
    return forAll((comp) => {
        const cid = comp.Id;
        if (containsKey(cid, Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, DrawModelType_SheetT_symbols_)(model.Sheet))) {
            const newDefault = inputValueAt(model, fs, comp, clocktick);
            const typ = Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, DrawModelType_SheetT_symbolOf_(cid))(model.Sheet).Component.Type;
            let matchResult, d;
            if (typ.tag === 0) {
                if (typ.fields[1] != null) {
                    matchResult = 0;
                    d = typ.fields[1];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return equals_1(d, newDefault);
                default:
                    return equals_1(newDefault, fromZero());
            }
        }
        else {
            return true;
        }
    }, topLevelInputs(fs));
}

/**
 * Whether Refresh can rebuild without asking: have the inputs held their default values for the
 * whole run so far, so that restarting loses nothing the user set?
 * 
 * With the .NET simulator that question cannot be asked here - the whole run is in the sidecar,
 * and this process's arrays were never written - so the one it CAN ask is asked instead: do the
 * inputs match their defaults at the clock on screen. The two differ only for an input that was
 * changed and then put back, where this says nothing was changed and Refresh does not stop to
 * ask. Reading the run's history over the wire is what would give the exact question back.
 */
export function InputDefaultsEqualInputsRefresh(fs, model, clocktick) {
    if (!model.SimulateInRenderer) {
        return InputDefaultsEqualInputs(fs, model, clocktick);
    }
    else {
        const tick = fs.ClockTick | 0;
        return forAll_1((x) => x, map_1((fc_1) => {
            let d;
            const cid = fc_1.cId;
            if (containsKey(cid, Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, DrawModelType_SheetT_symbols_)(model.Sheet))) {
                const typ = Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, DrawModelType_SheetT_symbolOf_(cid))(model.Sheet).Component.Type;
                return outputsAreTheSameAsDefault(fs, fc_1, tick, (typ.tag === 0) ? ((typ.fields[1] != null) ? ((d = typ.fields[1], d)) : fromZero()) : fromZero());
            }
            else {
                return true;
            }
        }, fs.FCompsByIndex.filter((fc) => {
            if (equals(fc.AccessPath, empty())) {
                if (fc.FType.tag === 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        })));
    }
}

export function setInputDefaultsFromInputs(model, fs, dispatch, clocktick) {
    iterate((comp_1) => {
        let f_2, f, updateFn, newDefault;
        dispatch(new Msg(/* UpdateModel */ 41, [(f_2 = ((f = ((updateFn = ((newDefault = inputValueAt(model, fs, comp_1, clocktick), (sym) => {
            let matchValue;
            const comp = sym.Component;
            return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, new Component(comp.Id, (matchValue = comp.Type, (matchValue.tag === 0) ? (new ComponentType(/* Input1 */ 0, [matchValue.fields[0], newDefault])) : matchValue), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo), sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
        })), (model_1) => {
            const compId = comp_1.Id;
            const model_2 = model_1;
            return new DrawModelType_SymbolT_Model(FSharpMap__Add(model_2.Symbols, compId, updateFn(FSharpMap__get_Item(model_2.Symbols, compId))), model_2.CopiedSymbols, model_2.Ports, model_2.InputPortsConnected, model_2.OutputPortsConnected, model_2.Theme, model_2.HintPane);
        })), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_symbol_)(f))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, sheet_)(f_2))]));
    }, topLevelInputs(fs));
}

export function changeBase(dispatch, numBase) {
    return dispatch(new Msg(/* SetSimulationBase */ 26, [numBase]));
}

function splittedLine(leftContent, rightConent) {
    return level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
        marginBottom: "10px",
    }])])), ofArray([left_1(empty(), singleton(item(empty(), singleton(leftContent)))), right_1(empty(), singleton(item(empty(), singleton(rightConent))))]));
}

function viewerInstances(fs) {
    return SimulatedDesign__InstancesOfComponents_Z5E942382(fs.Design, (comp) => (comp.Type.tag === 2));
}

function outputWidthOf(fs, _arg1_, _arg1__1) {
    let option_1;
    const _arg = [_arg1_, _arg1__1];
    return defaultArg((option_1 = tryFind((p) => {
        if (equals(p.PortComp, _arg[0]) && equals(p.PortIs, PortType.Output)) {
            return p.PortNum === 0;
        }
        else {
            return false;
        }
    }, ofInstanceCached(fs, _arg[1]).ViewPorts), (option_1 != null) ? option_1.PortWidth : undefined), 0) | 0;
}

/**
 * One clock of the panel's signals, named the way the sidecar names them. Every one is an
 * output port 0: an input's own value, an output's value, a viewer's, or a register's state.
 */
export function panelSignals(simData) {
    const asSignal = (tupledArg) => (new PanelSignal(tupledArg[0], map((_arg_1) => _arg_1, tupledArg[1]), 0));
    return List_distinct(append(map((tupledArg_1) => asSignal([tupledArg_1[0], empty()]), append(simData.Inputs, simData.Outputs)), append(map((tupledArg_2) => asSignal([tupledArg_2[0].Id, tupledArg_2[1]]), viewerInstances(simData.FastSim)), map((comp_1) => asSignal([comp_1.Id, empty()]), topRegisters(simData.FastSim)))), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

function panelValue(cycle, width, signal) {
    return new FSInterface(/* IData */ 0, [convertBigintToFastData(width, defaultArg(valueAt(cycle, signal), fromZero()))]);
}

/**
 * The clock a run should advance FROM: what the panel is showing now.
 * 
 * Locally the FastSimulation's own tick and the model's are the same number - the model is
 * incremented by exactly what was run - and the FastSimulation's is used because it is the one
 * that cannot be stale. In sidecar mode the local simulation is built and never run, so its tick
 * is 0 for ever; the sidecar's own clock is not the answer either, since it only ever goes
 * forwards while the panel can be stepped back. The model's clock is what is on screen.
 */
export function clockNow(model, simData) {
    if (model.SimulateInRenderer) {
        return simData.FastSim.ClockTick | 0;
    }
    else {
        return simData.ClockTickNumber | 0;
    }
}

/**
 * Where the step panel is after a chunk that was aiming for `target`, given what the chunk
 * answered: the clock it reached, and whether it got there.
 * 
 * **Not the clock the simulator reports.** Those are different numbers - section G2 of
 * docs/dev/sidecarInvariants.md says so in as many words: the simulator's clock is how far it has
 * RUN, the panel's is where the user is LOOKING, and stepping back to a cycle still inside the
 * circular buffer needs no running at all. `runFastSimulationCore` answers such a step
 * `RunCompleted` with its clock untouched and AHEAD of the target, which taken for the panel's
 * position sent a goto backwards forwards instead - to wherever the simulation happened to have
 * run to, with the progress bar past its own maximum.
 * 
 * So a chunk that finished puts the panel at the cycle that was asked for, and one that ran out
 * of budget puts it at the clock reached, which is honest progress towards it. The local
 * simulator has always been read this way (`RunCompleted -> cycle`); this is the same rule said
 * once, for both.
 */
export function panelClockAfter(target, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    if (_arg[1]) {
        return target | 0;
    }
    else {
        return _arg[0] | 0;
    }
}

/**
 * How many clock cycles of history the step simulator can afford on this design, or why it
 * cannot be simulated at all.
 * 
 * The waveform simulator has a configuration dialog that prices the design and refuses a last
 * clock that will not fit (`FastCreate.maxLastClockFor`, `UIPopups`); the step simulator has no
 * dialog and used to take `Constants.maxArraySize` whatever the design cost - so a design too
 * big for it was refused by the build's own memory check, in words about a waveform
 * configuration the user was not looking at.
 * 
 * The budget binds here instead, on the one number this simulator has. It asks for the full
 * array - enough past to step back through - and takes what fits if that is too much, down to
 * `minStepArraySize`. Below that the design is refused, with a message about the design.
 * 
 * Priced from the design's merged graph, so this allocates nothing: the check happens before the
 * arrays it is deciding the size of exist, which is the whole point of it.
 */
export function stepSimArraySize(model) {
    let option_1;
    const sheet = defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? option_1.OpenFileName : undefined), "");
    const matchValue = designStepCost(model, sheet);
    if (matchValue.tag === 0) {
        const cost = matchValue.fields[0];
        const matchValue_1 = stepSimCycles(Constants_maxArraySize, cost);
        if (matchValue_1 == null) {
            const perCycle_1 = SimulationBudget_formatBytes(StepCost__get_TotalBytes(cost));
            const needed = SimulationBudget_formatBytes(StepCost__get_TotalBytes(cost) * Constants_minStepArraySize);
            return new FSharpResult$2(/* Error */ 1, [new SimulationError(new SimulationErrorType(/* GenericSimError */ 20, [(concat("This design needs ", perCycle_1, " of simulation memory for every clock cycle, so even ") + (`the ${Constants_minStepArraySize} clock cycles the step simulator keeps would need ${needed} - more `)) + "than Issie will risk. Simulate one subsheet rather than the whole design."]), undefined, empty(), empty())]);
        }
        else {
            const size = matchValue_1 | 0;
            if (size < Constants_maxArraySize) {
                dbg(32, `step simulation of '${sheet}' shortened to ${size} cycles of history: ${SimulationBudget_formatBytes(StepCost__get_TotalBytes(cost))} a cycle`);
            }
            return new FSharpResult$2(/* Ok */ 0, [size]);
        }
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [Constants_maxArraySize]);
    }
}

/**
 * How many clock cycles of history the RENDERER's own step simulation holds.
 * 
 * The same as the simulation's, when the renderer is running it. When the .NET simulator is, this
 * copy is built for its structure and never run - the panel's values, its memories and its clock
 * all come from the sidecar - so it holds the least a built simulation can. What the SIDECAR
 * holds is `stepSimArraySize` either way: that is the history the step simulator can be stepped
 * back through, and it is a fact about the design rather than about which process is running it.
 */
export function rendererStepArraySize(model) {
    return Result_Map((size) => {
        if (model.SimulateInRenderer) {
            return size | 0;
        }
        else {
            return Constants_rendererArraySizeWhenSidecarSimulates | 0;
        }
    }, stepSimArraySize(model));
}

/**
 * Advance whichever simulator is running TOWARDS `cycle`, for at most one chunk, and say what
 * clock it reached.
 * 
 * **One chunk, not a run.** A second of simulation, or the cycle asked for, whichever comes
 * first. Getting all the way there is the caller's business: `simulateWithProgressBar` asks
 * again until it arrives, which is the same shape the waveform simulator's run has and for the
 * same reasons - the loop is in the update function, nothing is ever interrupted, and stopping is
 * not asking for the next chunk.
 * 
 * Both simulators can do this. `FastRun.runFastSimulation` takes a time budget and says where it
 * stopped; `SidecarSession.runChunk` does the same over the wire. So there is nothing to estimate
 * and no per-simulator arithmetic: how far a second gets is measured, by running for a second.
 * 
 * Local: the FastSimulation is run here and `whenReady` is called at once, exactly as before.
 * Sidecar: the session is run a chunk and the panel's signals read back into StepPanelData, then
 * `whenReady`. If the sidecar does not hold the design, a build is STARTED - an operation, with
 * the model saying so until it answers - and this advance does nothing; the next one finds a
 * session and runs it.
 */
export function advanceTo(model, simData, cycle, dispatch, whenReady) {
    if (model.SimulateInRenderer) {
        let reached;
        const matchValue = runFastSimulation(Constants_advanceChunkMs, cycle, simData.FastSim);
        reached = ((matchValue.tag === 1) ? matchValue.fields[0] : cycle);
        forget();
        whenReady(reached);
    }
    else {
        const matchValue_1 = model.CurrentProj;
        if (matchValue_1 != null) {
            const top = FastSimulation__get_SimulatedTopSheet(simData.FastSim);
            const failed = (what, e) => {
                logFailure(concat("the .NET simulator could not ", what), e);
                forget();
            };
            const sidecarArraySize = Result_DefaultValue(Constants_maxArraySize, stepSimArraySize(model)) | 0;
            const matchValue_2 = model.SidecarSession;
            if (sidecarIsBusy(model)) {
                whenReady(simData.ClockTickNumber);
            }
            else if (SidecarSessionState__Holds_Z18115A39(matchValue_2, top, sidecarArraySize)) {
                let pr_1;
                const epoch = value_2(SidecarSessionState__get_Epoch(matchValue_2)) | 0;
                const seq = newSeq();
                dispatch(new Msg(/* SidecarOpStarted */ 30, [seq, new SidecarOp(/* OpStep */ 3, [cycle])]));
                const finish = (reached_1) => {
                    dispatch(new Msg(/* SidecarReply */ 31, [seq, SidecarAnswer.AnsStepped]));
                    whenReady(reached_1);
                };
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (runChunk(epoch, cycle).then((_arg) => {
                    if (_arg.tag === 0) {
                        const outcome = _arg.fields[0];
                        finish(panelClockAfter(cycle, outcome[0], outcome[1]));
                        return Promise.resolve();
                    }
                    else {
                        failed(`run to cycle ${cycle}`, _arg.fields[0]);
                        finish(simData.ClockTickNumber);
                        return Promise.resolve();
                    }
                }))));
                pr_1 = (pr.catch((e_2) => {
                    failed(`run to cycle ${cycle}`, transportFailure(e_2.message));
                    finish(simData.ClockTickNumber);
                }));
                void pr_1;
            }
            else {
                error_1("cannot advance the step simulation: the .NET simulator holds no session for it");
                whenReady(simData.ClockTickNumber);
            }
        }
        else {
            whenReady(simData.ClockTickNumber);
        }
    }
}

/**
 * Set a top-level input at the shown cycle, on whichever simulator is running, and make the
 * panel's values for that cycle current again.
 * 
 * Locally that is one call: changeInput sets the value and re-runs the combinational logic at
 * that step. Over the wire it is SimSetInputs and then a re-read, because the values the panel
 * is showing were computed from the input this just changed.
 * 
 * **Values up to 2^53.** SimSetInputs carries a value as two 32-bit words, so a wider input
 * cannot be set from here yet; it is refused by name rather than sent truncated, which would
 * show the user a value the simulation is not running on.
 */
export function setInput(model, simData, compId, value, whenReady) {
    if (model.SimulateInRenderer) {
        changeInput(compId, new FSInterface(/* IData */ 0, [value]), simData.ClockTickNumber, simData.FastSim);
        whenReady();
    }
    else {
        const cycle = simData.ClockTickNumber | 0;
        let asBigInt;
        const matchValue = value.Dat;
        asBigInt = ((matchValue.tag === 1) ? matchValue.fields[0] : fromUInt32(matchValue.fields[0]));
        const matchValue_1 = SidecarSessionState__get_Epoch(model.SidecarSession);
        if (compare(asBigInt, fromInt64(9007199254740992n)) > 0) {
            error_1(`the .NET simulator cannot yet be given a ${value.Width}-bit input value this large - Development > Simulate In Renderer can set it`);
            whenReady();
        }
        else if (matchValue_1 != null) {
            const epoch = matchValue_1 | 0;
            let pr_1;
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (simSetInputs(epoch, cycle, singleton([compId, toFloat64(asBigInt)])).then((_arg) => {
                let matchValue_2;
                return ((matchValue_2 = errorIn(_arg), (matchValue_2 == null) ? (fill(epoch, cycle, panelSignals(simData)).then((_arg_1) => {
                    if (_arg_1.tag === 0) {
                        return Promise.resolve();
                    }
                    else {
                        error_1(`the .NET simulator could not read cycle ${cycle} back: ${_arg_1.fields[0]}`);
                        forget();
                        return Promise.resolve();
                    }
                })) : ((error_1(`the .NET simulator could not set an input: ${matchValue_2}`), (forget(), Promise.resolve()))))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    whenReady();
                    return Promise.resolve();
                }));
            }))));
            pr_1 = (pr.catch((e_2) => {
                error_1(concat("the .NET simulator could not set an input: ", e_2.message));
                forget();
                whenReady();
            }));
            void pr_1;
        }
        else {
            error_1("there is no .NET simulation to set an input on");
            whenReady();
        }
    }
}

/**
 * The panel's top-level input or output values, from whichever simulator is running.
 */
export function ioValues(model, simData, ios) {
    if (model.SimulateInRenderer) {
        return extractFastSimulationIOs(ios, simData);
    }
    else {
        return map((io) => {
            const io_1 = io;
            return [io_1, panelValue(simData.ClockTickNumber, io_1[2], new PanelSignal(io_1[0], empty(), 0))];
        }, ios);
    }
}

/**
 * The panel's viewer values, from whichever simulator is running.
 * 
 * The LIST is the design's, so both simulators show the same viewers under the same names in the
 * same order; only where the value comes from differs, which is the one thing that should.
 */
export function viewerValues(model, simData) {
    const fs = simData.FastSim;
    return map((instance) => {
        let tupledArg;
        const instance_1 = instance;
        const comp = instance_1[0];
        const ap = instance_1[1];
        const fId = [comp.Id, ap];
        const width = outputWidthOf(fs, fId[0], fId[1]) | 0;
        const value = model.SimulateInRenderer ? extractFastSimulationOutput(fs, simData.ClockTickNumber, fId[0], fId[1], 0) : panelValue(simData.ClockTickNumber, width, new PanelSignal(cToInt(comp.Id), map((_arg) => _arg, ap), 0));
        return [[comp.Label, (tupledArg = instance_1, SimulatedDesign__FullNameOf_Z7956074D(fs.Design, tupledArg[0], tupledArg[1]))], width, value];
    }, viewerInstances(fs));
}

/**
 * The panel's stateful rows, from whichever simulator is running.
 * 
 * In sidecar mode this is the registers and counters only - their state is Outputs[0], so it is
 * a signal like any other - and a memory is left out because its contents cannot be read over
 * the wire yet. `ramsAreLocalOnly` below is what tells the user that, rather than a table of
 * whatever the unrun local simulation happens to hold.
 */
export function statefulValues(model, simData) {
    if (model.SimulateInRenderer) {
        return map_1((tupledArg) => {
            const fc = tupledArg[0];
            return [fc.FullName, fc.FType, tupledArg[1]];
        }, extractStatefulComponents(simData.ClockTickNumber, simData.FastSim));
    }
    else {
        return toArray(map((comp) => [comp.Label, comp.Type, new SimulationComponentState(/* RegisterState */ 2, [convertBigintToFastData(outputWidthOf(simData.FastSim, comp.Id, empty()), defaultArg(valueAt(simData.ClockTickNumber, new PanelSignal(cToInt(comp.Id), empty(), 0)), fromZero()))])], topRegisters(simData.FastSim)));
    }
}

/**
 * The top-level memories the stateful panel offers a View button for.
 * 
 * They are not part of `statefulValues` in sidecar mode - a memory's contents live in its store
 * rather than on a wire, so they are not a signal to be read with the rest - and are listed here
 * instead, to be read only when the button is pressed.
 */
export function ramComponents(simData) {
    return topComponentsWhere((comp) => {
        const matchValue = comp.Type;
        switch (matchValue.tag) {
            case 41:
            case 42:
                return true;
            default:
                return false;
        }
    }, simData.FastSim);
}

/**
 * Read one memory from the .NET simulator and open the diff against its initial contents.
 * 
 * No cache and no held state, unlike the waveform simulator's RAM table: this happens when a
 * button is pressed, and a button press can wait for a reply the way any other click can. What
 * makes the table different is that it is drawn from `view`, which cannot wait for anything.
 * 
 * A diff needs the whole memory on both sides, so the request asks for a listing and nothing
 * else. A window coming back means the memory is written in too many places to read whole -
 * `RamStore.Constants.maxSlotsForWholeRead` - which is the same answer the local button gives by
 * disabling itself, said after the fact because only the far side knows.
 */
export function openRemoteRamDiff(ram, cycle, model, dispatch) {
    let initial;
    const matchValue = ram.Type;
    let matchResult, m;
    switch (matchValue.tag) {
        case 41: {
            matchResult = 0;
            m = matchValue.fields[0];
            break;
        }
        case 42: {
            matchResult = 0;
            m = matchValue.fields[0];
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            initial = m;
            break;
        }
        default:
            initial = toFail(`what? openRemoteRamDiff expected a RAM but got ${ram.Type}`);
    }
    const matchValue_1 = SidecarSessionState__get_Epoch(model.SidecarSession);
    if (matchValue_1 != null) {
        const epoch = matchValue_1 | 0;
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (simReadRam(epoch, cycle, cToInt(ram.Id), map((arg00$0040) => (cToInt(arg00$0040) | 0), empty()), Constants_maxSlotsForWholeRead, fromZero(), 0).then((_arg) => {
            let text;
            const reply = _arg;
            if (reply.tag === 0) {
                if (reply.fields[0].tag === 0) {
                    openMemoryDiffViewer(initial, new Memory1(initial.Init, initial.AddressWidth, initial.WordWidth, ofList(map((r_1) => [r_1.Addr, r_1.Value], filter((r) => !equals_1(r.Value, fromZero()), reply.fields[0].fields[0])), {
                        Compare: (x, y) => (compare(x, y) | 0),
                    }), initial.Comments), model, dispatch);
                    return Promise.resolve();
                }
                else {
                    dispatch(new Msg(/* SetSimulationNotification */ 76, [(text = concat("\'", ram.Label, "\' has been written in too many places to compare with its initial                       contents. The waveform simulator\'s RAM table shows a window of it."), (dispatch_1) => errorNotification(text, Msg.CloseSimulationNotification, dispatch_1))]));
                    return Promise.resolve();
                }
            }
            else {
                logFailure(concat("the .NET simulator could not read memory \'", ram.Label, "\'"), reply.fields[0]);
                return Promise.resolve();
            }
        }))));
        void pr;
    }
    else {
        error_1("there is no .NET simulation to read a memory from");
    }
}

/**
 * Pretty print a label with its width.
 */
export function makeIOLabel(label, width) {
    const label_1 = cropToLength(15, true, label);
    if (width === 1) {
        return label_1;
    }
    else {
        return toText(printf("%s (%d bits)"))(label_1)(width);
    }
}

function viewSimulationInputs(numberBase, model, simulationData, inputs, dispatch) {
    const simulationGraph = simulationData.Graph;
    const children = map((tupledArg) => {
        const _arg = tupledArg[0];
        const inputVals = tupledArg[1];
        const width = _arg[2] | 0;
        const inputId = _arg[0];
        let valueHandle;
        let matchResult, bit, bits;
        if (inputVals.tag === 1) {
            matchResult = 2;
        }
        else if (inputVals.fields[0].Dat.tag === 0) {
            if (inputVals.fields[0].Width === 1) {
                matchResult = 0;
                bit = inputVals.fields[0].Dat.fields[0];
            }
            else {
                matchResult = 1;
                bits = inputVals.fields[0];
            }
        }
        else {
            matchResult = 1;
            bits = inputVals.fields[0];
        }
        switch (matchResult) {
            case 0: {
                valueHandle = button(ofArray([new Option(/* Props */ 17, [singleton(simulationBitStyle)]), (bit === 0) ? (new Option(/* Color */ 0, [Color_IColor.IsGreyLighter])) : (new Option(/* Color */ 0, [Color_IColor.IsPrimary])), new Option(/* IsHovered */ 10, [false]), new Option(/* OnClick */ 18, [(_arg_1) => {
                    setInput(model, simulationData, inputId, new FastData(new FastBits(/* Word */ 0, [1 - bit]), 1), () => {
                        dispatch(new Msg(/* UpdateModel */ 41, [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, stimulusGeneration_)((y) => ((1 + y) | 0))]));
                        dispatch(new Msg(/* SetSimulationGraph */ 25, [simulationGraph, simulationData.FastSim]));
                    });
                }])]), singleton(bitToString((bit === 0) ? Bit.Zero : Bit.One)));
                break;
            }
            case 1: {
                const defValue = fastDataToPaddedString(Constants_boxMaxChars, numberBase, bits);
                valueHandle = input(ofArray([new Option_1(/* Type */ 1, [IInputType.Text$]), new Option_1(/* Key */ 9, [toString(numberBase)]), new Option_1(/* DefaultValue */ 10, [defValue]), new Option_1(/* Props */ 15, [ofArray([simulationNumberStyle, new DOMAttr(/* OnChange */ 9, [(arg_3) => {
                    const matchValue = strToIntCheckWidth(width, getTextEventValue(arg_3));
                    if (matchValue.tag === 0) {
                        const bits_1 = convertBigintToFastData(width, matchValue.fields[0]);
                        dispatch(Msg.CloseSimulationNotification);
                        setInput(model, simulationData, inputId, bits_1, () => {
                            dispatch(new Msg(/* UpdateModel */ 41, [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, stimulusGeneration_)((y_1) => ((1 + y_1) | 0))]));
                            dispatch(new Msg(/* SetSimulationGraph */ 25, [simulationGraph, simulationData.FastSim]));
                        });
                    }
                    else {
                        dispatch(new Msg(/* SetSimulationNotification */ 76, [errorPropsNotification(matchValue.fields[0])]));
                    }
                }])])])]));
                break;
            }
            default:
                valueHandle = toFail(printf("what? Algebra in Step Simulation (not yet implemented)"));
        }
        return splittedLine(makeIOLabel(_arg[1], width), valueHandle);
    }, inputs);
    return react_1.createElement("div", {}, ...children);
}

function staticBitButton(bit) {
    return button(ofArray([new Option(/* Props */ 17, [singleton(simulationBitStyle)]), (bit.tag === 1) ? (new Option(/* Color */ 0, [Color_IColor.IsPrimary])) : (new Option(/* Color */ 0, [Color_IColor.IsGreyLighter])), new Option(/* IsHovered */ 10, [false]), new Option(/* Disabled */ 16, [true])]), singleton(bitToString(bit)));
}

function staticNumberBox(maxChars, numBase, bits) {
    return input(ofArray([new Option_1(/* Type */ 1, [IInputType.Text$]), new Option_1(/* IsReadOnly */ 5, [true]), new Option_1(/* Value */ 8, [fastDataToPaddedString(maxChars, numBase, bits)]), new Option_1(/* Props */ 15, [singleton(simulationNumberStyle)])]));
}

function viewSimulationOutputs(numBase, simOutputs) {
    const children = map((tupledArg) => {
        const _arg = tupledArg[0];
        const inputVals = tupledArg[1];
        const valueHandle = (inputVals.tag === 1) ? toFail(printf("what? Algebra in Step Simulation (not yet implemented)")) : ((inputVals.fields[0].Dat.tag === 0) ? ((inputVals.fields[0].Width === 1) ? staticBitButton((inputVals.fields[0].Dat.fields[0] === 0) ? Bit.Zero : Bit.One) : staticNumberBox(Constants_boxMaxChars, numBase, inputVals.fields[0])) : staticNumberBox(Constants_boxMaxChars, numBase, inputVals.fields[0]));
        return splittedLine(makeIOLabel(_arg[1], _arg[2]), valueHandle);
    }, simOutputs);
    return react_1.createElement("div", {}, ...children);
}

function viewViewers(numBase, simViewers) {
    const children_2 = map((tupledArg) => {
        let r, props;
        const _arg = tupledArg[0];
        const inputVals = tupledArg[2];
        const fullName = _arg[1];
        const valueHandle = (inputVals.tag === 1) ? toFail(printf("what? Algebra in Step Simulation (not yet implemented)")) : ((inputVals.fields[0].Dat.tag === 0) ? ((inputVals.fields[0].Width === 1) ? staticBitButton((inputVals.fields[0].Dat.fields[0] === 0) ? Bit.Zero : Bit.One) : staticNumberBox(Constants_boxMaxChars, numBase, inputVals.fields[0])) : staticNumberBox(Constants_boxMaxChars, numBase, inputVals.fields[0]));
        return splittedLine((r = makeIOLabel(_arg[0], tupledArg[1]), (fullName !== "") ? ((props = [new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " has-tooltip-right")]), dataTooltip(fullName)], react_1.createElement("div", keyValueList(props, 1), r))) : r), valueHandle);
    }, simViewers);
    return react_1.createElement("div", {}, ...children_2);
}

function viewStatefulComponents(step, comps, numBase, model, dispatch) {
    const children = collect((_arg) => {
        const state = _arg[2];
        let label;
        const lab = _arg[0];
        label = ((lab === "") ? "no-label" : lab);
        switch (state.tag) {
            case 2:
                if (state.fields[0].Width === 1) {
                    const bit = equals(state.fields[0], fastDataZero) ? Bit.Zero : Bit.One;
                    return singleton(splittedLine(toText(printf("DFF: %s"))(label), staticBitButton(bit)));
                }
                else {
                    return singleton(splittedLine(toText(printf("Register: %s (%d bits)"))(label)(state.fields[0].Width), staticNumberBox(Constants_boxMaxChars, numBase, state.fields[0])));
                }
            case 3: {
                const label_3 = toText(printf("RAM: %s"))(label);
                const fits = state.fields[0].SlotCount <= Constants_maxSlotsForWholeRead;
                return singleton(splittedLine(label_3, button(ofArray([new Option(/* Props */ 17, [toList(delay(() => append_1(singleton_1(simulationBitStyle), delay(() => (!fits ? singleton_1(dataTooltip("This memory has been written in too many places to compare with its initial contents. The waveform simulator\'s RAM table shows a window of it.")) : empty_1())))))]), new Option(/* Color */ 0, [fits ? Color_IColor.IsPrimary : Color_IColor.IsGreyLight]), new Option(/* Disabled */ 16, [!fits]), new Option(/* OnClick */ 18, [(_arg_1) => {
                    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, _arg_2) => {
                        let compType_1;
                        const matchValue = toMemoryIfSmall(state.fields[0], step);
                        if (matchValue == null) {
                        }
                        else {
                            const mem = matchValue;
                            openMemoryDiffViewer((compType_1 = _arg[1], (compType_1.tag === 41) ? compType_1.fields[0] : ((compType_1.tag === 42) ? compType_1.fields[0] : toFail(printf("what? viewStatefulComponents expected RAM component but got: %A"))(compType_1))), mem, model_1, dispatch);
                        }
                    }, dispatch]));
                }])]), singleton("View"))));
            }
            default:
                return empty();
        }
    }, comps);
    return react_1.createElement("div", {}, ...children);
}

export function getSimErrFeedbackMessages(simError, model) {
    if (simError.InDependency == null) {
        const badConns = simError.ConnectionsAffected;
        const badComps = simError.ComponentsAffected;
        const msgs = singleton(new Msg(/* SetHighlighted */ 35, [badComps, badConns]));
        if (!isAllVisible(model.Sheet, badConns, badComps)) {
            return append(msgs, singleton(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlW])])));
        }
        else {
            return msgs;
        }
    }
    else {
        return empty();
    }
}

export function setSimErrorFeedback(simError, model, dispatch) {
    iterate(dispatch, getSimErrFeedbackMessages(simError, model));
}

/**
 * get the position and rotation for inserting a new component next to the given port
 * at a given distance
 * the rotation is such that the original left side of the component (input side)
 * faces the given port
 * returns None if another symbol is in the way
 */
export function getPosRotNextToPort(port, model, dist) {
    let pos;
    let sym_2;
    const _arg_1 = tryFind((tupledArg) => equals(tupledArg[1].Component.Id, port.HostId), toList_1(model.Symbols));
    sym_2 = ((_arg_1 == null) ? toFail(printf("The given component should be in the list of symbols")) : _arg_1[1]);
    const edge = FSharpMap__get_Item(sym_2.PortMaps.Orientation, port.Id);
    const portPos = getPortPos(sym_2, port);
    const patternInput = (edge.tag === 0) ? [new XYPos(sym_2.Pos.X + portPos.X, (sym_2.Pos.Y + portPos.Y) - dist), Rotation.Degree90] : ((edge.tag === 2) ? [new XYPos((sym_2.Pos.X + portPos.X) - dist, sym_2.Pos.Y + portPos.Y), Rotation.Degree180] : ((edge.tag === 1) ? [new XYPos(sym_2.Pos.X + portPos.X, (sym_2.Pos.Y + portPos.Y) + dist), Rotation.Degree270] : [new XYPos((sym_2.Pos.X + portPos.X) + dist, sym_2.Pos.Y + portPos.Y), Rotation.Degree0]));
    const pos_1 = patternInput[0];
    if (exists((pos = pos_1, (boundingBox) => ((((pos.X > boundingBox.TopLeft.X) && (pos.X < (boundingBox.TopLeft.X + boundingBox.W))) && (pos.Y > boundingBox.TopLeft.Y)) && (pos.Y < (boundingBox.TopLeft.Y + boundingBox.H)))), map((tupledArg_1) => {
        let left, right;
        const sym_4 = tupledArg_1[1];
        let patternInput_1;
        const sym_5 = sym_4;
        const comp = sym_5.Component;
        const matchValue = defaultArg(sym_5.HScale, 1);
        const vS = defaultArg(sym_5.VScale, 1);
        const hS = matchValue;
        const matchValue_2 = sym_5.STransform.Rotation;
        switch (matchValue_2.tag) {
            case 1:
            case 3: {
                patternInput_1 = [comp.W * hS, comp.H * vS];
                break;
            }
            default:
                patternInput_1 = [comp.H * vS, comp.W * hS];
        }
        if (equals(sym_4.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton)) {
            return new BoundingBox((left = sym_4.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17);
        }
        else {
            return new BoundingBox(sym_4.Pos, patternInput_1[1], patternInput_1[0]);
        }
    }, toList_1(model.Symbols)))) {
        return undefined;
    }
    else {
        return [pos_1, patternInput[1]];
    }
}

export function viewSimulationError(comps, conns, simError, model, simType, dispatch) {
    const sheetDispatch = (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    };
    const busWireDispatch = (bMsg) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [bMsg]));
    };
    const changeAdderType = (compId, targetType, model_1, _arg) => {
        DrawModelType_SheetT_Model__Model_ChangeAdderComp(model_1.Sheet, sheetDispatch, compId, targetType);
    };
    const getComponentByIdListOpt = (compId_4) => {
        const _arg_2 = tryFind((comp) => equals(comp.Id, compId_4), comps);
        if (_arg_2 == null) {
            warn("an errored component from the simulation is missing, and will be ignored");
            return empty();
        }
        else {
            return singleton(_arg_2);
        }
    };
    const reacListOfCompsAffected = map((comp_3) => react_1.createElement("li", {}, comp_3.Label), collect(getComponentByIdListOpt, simError.ComponentsAffected));
    const getCompAndPortAffectedMsg = (comp_4, port) => ((comp_4.Label + ".") + getPortName(comp_4, port));
    const cleanup = () => {
        simReset(dispatch);
        dispatch(new Msg(/* TryStartSimulationAfterErrorFix */ 24, [simType]));
    };
    let error;
    const comps_1 = collect(getComponentByIdListOpt, simError.ComponentsAffected);
    const matchValue = simError.ErrType;
    let matchResult, comp_5, port_1, rmInfo, comp_6, port_2, rmInfo_1;
    if (!isEmpty(comps_1)) {
        if (isEmpty(tail(comps_1))) {
            switch (matchValue.tag) {
                case 12: {
                    if (matchValue.fields[0] === 0) {
                        matchResult = 0;
                        comp_5 = head(comps_1);
                        port_1 = matchValue.fields[1];
                        rmInfo = matchValue.fields[2];
                    }
                    else {
                        matchResult = 3;
                    }
                    break;
                }
                case 11: {
                    if (matchValue.fields[0] === 0) {
                        matchResult = 1;
                        comp_6 = head(comps_1);
                        port_2 = matchValue.fields[1];
                        rmInfo_1 = matchValue.fields[2];
                    }
                    else {
                        matchResult = 3;
                    }
                    break;
                }
                case 18: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 3;
            }
        }
        else if (matchValue.tag === 18) {
            matchResult = 2;
        }
        else {
            matchResult = 3;
        }
    }
    else if (matchValue.tag === 18) {
        matchResult = 2;
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0: {
            let buttonOrText;
            if (rmInfo.tag === 0) {
                const _arg_6 = getPosRotNextToPort(port_1, model.Sheet.Wire.Symbol, Constants_ncPortDist);
                if (_arg_6 == null) {
                    buttonOrText = "Please insert a \'Not Connected\' component manually";
                }
                else {
                    const rot = _arg_6[1];
                    const pos = _arg_6[0];
                    buttonOrText = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_8) => {
                        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_4, _arg_7) => {
                            sheetDispatch(new DrawModelType_SheetT_Msg(/* AddNotConnected */ 13, [tryGetLoadedComponents(model_4), port_1, pos, rot]));
                            cleanup();
                        }, dispatch]));
                    }])]), singleton("Fix by adding \'Not Connected\' component"));
                }
            }
            else {
                buttonOrText = button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_5) => {
                    let tupledArg;
                    dispatch((tupledArg = [(model_3) => ((_arg_4) => {
                        changeAdderType(comp_5.Id, rmInfo.fields[0], model_3, undefined);
                        cleanup();
                    }), dispatch], new Msg(/* ExecFuncInMessage */ 116, [uncurry2(tupledArg[0]), tupledArg[1]])));
                }])]), singleton("Fix by deleting the port on the component"));
            }
            const children_2 = [errorMessage(dispatch, errMsg(simError.ErrType)), react_1.createElement("br", {}), react_1.createElement("br", {}), getCompAndPortAffectedMsg(comp_5, port_1), react_1.createElement("br", {}), buttonOrText];
            error = react_1.createElement("div", {}, ...children_2);
            break;
        }
        case 1: {
            (comp_6.Label + ".") + getPortName(comp_6, port_2);
            const compId_5 = comp_6.Id;
            const showButton = !(rmInfo_1.tag === 0);
            const children_4 = toList(delay(() => append_1(singleton_1(errorMessage(dispatch, errMsg(simError.ErrType))), delay(() => append_1(singleton_1(react_1.createElement("br", {})), delay(() => append_1(singleton_1(react_1.createElement("br", {})), delay(() => append_1(singleton_1(getCompAndPortAffectedMsg(comp_6, port_2)), delay(() => append_1(singleton_1(react_1.createElement("br", {})), delay(() => (showButton ? singleton_1(button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_10) => {
                dispatch(new Msg(/* ExecFuncInMessage */ 116, [(moel, _arg_9) => {
                    if (rmInfo_1.tag === 0) {
                        toFail(printf("This function should never be called if not input ports can be removed"));
                    }
                    else {
                        const targetType_3 = rmInfo_1.fields[0];
                        switch (targetType_3.tag) {
                            case 17:
                            case 18:
                            case 19:
                            case 20: {
                                changeAdderType(compId_5, targetType_3, model, undefined);
                                break;
                            }
                            case 35:
                            case 37:
                            case 36:
                            case 38: {
                                DrawModelType_SheetT_Model__Model_ChangeCounterComp(model.Sheet, sheetDispatch, compId_5, targetType_3);
                                break;
                            }
                            default:
                                undefined;
                        }
                    }
                    simReset(dispatch);
                    dispatch(new Msg(/* TryStartSimulationAfterErrorFix */ 24, [simType]));
                }, dispatch]));
            }])]), singleton("Fix by deleting input port"))) : empty_1())))))))))))));
            error = react_1.createElement("div", {}, ...children_4);
            break;
        }
        case 2: {
            const children_8 = [errorMessage(dispatch, errMsg(simError.ErrType)), react_1.createElement("br", {}), react_1.createElement("br", {}), react_1.createElement("ul", {}, ...reacListOfCompsAffected), react_1.createElement("br", {}), button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_11) => {
                busWireDispatch(new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* DeleteSymbols */ 3, [map((conn_1) => conn_1.Target.HostId, collect((connId) => {
                    const _arg_3 = tryFind((conn) => equals(conn.Id, connId), conns);
                    if (_arg_3 == null) {
                        warn("an errored connection from the simulation is missing, and will be ignored");
                        return empty();
                    }
                    else {
                        return singleton(_arg_3);
                    }
                }, simError.ConnectionsAffected))])]));
                busWireDispatch(new DrawModelType_BusWireT_Msg(/* DeleteWires */ 4, [simError.ConnectionsAffected]));
                iterate((comp_7) => {
                    const matchValue_2 = comp_7.Type;
                    switch (matchValue_2.tag) {
                        case 17: {
                            dispatch(new Msg(/* ExecFuncInMessage */ 116, [uncurry2(curry4(changeAdderType)(comp_7.Id)(new ComponentType(/* NbitsAdderNoCout */ 19, [matchValue_2.fields[0]]))), dispatch]));
                            break;
                        }
                        case 18: {
                            dispatch(new Msg(/* ExecFuncInMessage */ 116, [uncurry2(curry4(changeAdderType)(comp_7.Id)(new ComponentType(/* NbitsAdderNoCinCout */ 20, [matchValue_2.fields[0]]))), dispatch]));
                            break;
                        }
                        default:
                            toFail(printf("Unexpected adder type. Should only encounter these 2 types with this error message"));
                    }
                }, collect(getComponentByIdListOpt, simError.ComponentsAffected));
                simReset(dispatch);
                dispatch(new Msg(/* TryStartSimulationAfterErrorFix */ 24, [simType]));
            }])]), singleton("Fix by deleting unnecessary \'Not Connected\' components"))];
            error = react_1.createElement("div", {}, ...children_8);
            break;
        }
        default: {
            const matchValue_3 = simError.InDependency;
            if (matchValue_3 != null) {
                const children_12 = [("Error found in sheet \'" + matchValue_3) + "\' which is a dependency:", react_1.createElement("br", {}), errorMessage(dispatch, errMsg(simError.ErrType)), react_1.createElement("br", {}), "Please fix the error in this sheet and retry."];
                error = react_1.createElement("div", {}, ...children_12);
            }
            else {
                const children_10 = [errorMessage(dispatch, errMsg(simError.ErrType)), react_1.createElement("br", {}), "Please fix the error and retry."];
                error = react_1.createElement("div", {}, ...children_10);
            }
        }
    }
    const children_14 = [h5(singleton(new Option_2(/* Props */ 9, [singleton(["style", {
        marginTop: "15px",
    }])])))(singleton("Errors")), error];
    return react_1.createElement("div", {}, ...children_14);
}

function simulationClockChangePopup(simData, dispatch, model$0027) {
    let children, matchValue, lastStepNeeded, n_1;
    const children_2 = [(children = [`This simulation contains ${SimulatedDesign__get_ExpandedComponentCount(simData.FastSim.Design)} components`], react_1.createElement("h6", {}, ...children)), (matchValue = model$0027.PopupDialogData.Int, (matchValue != null) ? (((lastStepNeeded = (matchValue | 0), (simData.FastSim.ClockTick - lastStepNeeded) >= simData.FastSim.MaxArraySize)) ? ((n_1 = (matchValue | 0), Text_p(singleton(new Common_GenericOption(/* Modifiers */ 2, [ofArray([new Modifier_IModifier(/* TextWeight */ 2, [TextWeight_Option.Bold]), new Modifier_IModifier(/* TextColor */ 1, [Color_IColor.IsDanger])])])), singleton(`To generate data for time step ${n_1}, 
                          the hardware will be resimulated using default inputs. `)))) : Text_p(singleton(new Common_GenericOption(/* Modifiers */ 2, [singleton(new Modifier_IModifier(/* TextWeight */ 2, [TextWeight_Option.Bold]))])), singleton("Go to Tick:"))) : Text_p(singleton(new Common_GenericOption(/* Modifiers */ 2, [singleton(new Modifier_IModifier(/* TextWeight */ 2, [TextWeight_Option.Bold]))])), singleton("Go to Tick:"))), react_1.createElement("br", {}), input(ofArray([new Option_1(/* Type */ 1, [IInputType.Number$]), new Option_1(/* Props */ 15, [ofArray([new HTMLAttr(/* AutoFocus */ 55, [true]), ["style", {
        width: "100px",
    }]])]), new Option_1(/* DefaultValue */ 10, [toText(printf("%d"))(simData.ClockTickNumber)]), new Option_1(/* OnChange */ 13, [(arg_3) => {
        dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_3)]));
    }])]))];
    return react_1.createElement("div", {}, ...children_2);
}

export function cmd(block) {
    return (task) => ((arg) => ((ofSuccess) => Cmd_OfAsyncWith_perform(block, task, arg, ofSuccess)));
}

export function doBatchOfMsgsAsynch(msgs) {
    const msg_2 = new Msg(/* ExecCmdAsynch */ 118, [Cmd_batch(map_2((msg) => singleton((dispatch) => {
        dispatch(msg);
    }), msgs))]);
    return singleton((dispatch_1) => {
        dispatch_1(msg_2);
    });
}

export function simulateWithProgressBar(simProg, model) {
    const matchValue = model.CurrentStepSimulationStep;
    const matchValue_1 = model.PopupDialogData.Progress;
    let matchResult, barData, simData;
    if (matchValue != null) {
        const copyOfStruct = matchValue;
        if (copyOfStruct.tag === 0) {
            if (matchValue_1 != null) {
                matchResult = 0;
                barData = matchValue_1;
                simData = copyOfStruct.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const nComps = SimulatedDesign__get_ExpandedComponentCount(simData.FastSim.Design);
            const oldClock = clockNow(model, simData) | 0;
            const t1 = getTimeMs();
            return [model, Cmd_ofEffect((dispatch) => {
                advanceTo(model, simData, simProg.FinalClock, dispatch, (reached) => {
                    const t2 = getTimeMs();
                    const speed = (t2 === t1) ? 0 : (((reached - oldClock) * nComps) / (t2 - t1));
                    iterate(dispatch, (reached >= simProg.FinalClock) ? ofArray([new Msg(/* SetSimulationGraph */ 25, [simData.Graph, simData.FastSim]), new Msg(/* IncrementSimulationClockTick */ 27, [reached - oldClock]), new Msg(/* SetPopupProgress */ 70, [undefined])]) : ofArray([new Msg(/* SetSimulationGraph */ 25, [simData.Graph, simData.FastSim]), new Msg(/* IncrementSimulationClockTick */ 27, [reached - oldClock]), new Msg(/* UpdatePopupProgress */ 71, [(barData_1) => (new PopupProgress(reached - simProg.InitialClock, barData_1.Max, barData_1.Title, speed))]), new Msg(/* SimulateWithProgressBar */ 72, [simProg])]));
                });
            })];
        }
        default:
            return [model, singleton((dispatch_1) => {
                dispatch_1(new Msg(/* SetPopupProgress */ 70, [undefined]));
            })];
    }
}

export function simulationClockChangeAction(dispatch, simData, model$0027) {
    let clock_1;
    const matchValue = model$0027.PopupDialogData.Int;
    clock_1 = ((matchValue != null) ? matchValue : toFail(printf("What - must have some number from dialog")));
    const initClock = ((clock_1 > simData.ClockTickNumber) ? simData.ClockTickNumber : 0) | 0;
    const steps = ((clock_1 > simData.ClockTickNumber) ? (clock_1 - simData.ClockTickNumber) : clock_1) | 0;
    const numComps = SimulatedDesign__get_ExpandedComponentCount(simData.FastSim.Design);
    const t1 = getTimeMs();
    if (!model$0027.SimulateInRenderer) {
        iterate(dispatch, ofArray([Msg.ClosePopup, new Msg(/* SetPopupProgress */ 70, [new PopupProgress(0, steps, "running simulation...", 0)]), new Msg(/* StartStepRun */ 73, [new SimulationProgress(initClock, clock_1)])]));
    }
    else {
        advanceTo(model$0027, simData, clock_1, dispatch, (reached) => {
            const t2 = getTimeMs();
            const speed = (t2 === t1) ? 0 : (((reached - simData.ClockTickNumber) * numComps) / (t2 - t1));
            dispatch(new Msg(/* ExecCmdAsynch */ 118, [Cmd_batch(map_2((msg) => singleton((dispatch_1) => {
                dispatch_1(msg);
            }), toList(delay(() => append_1(singleton_1(new Msg(/* SetSimulationGraph */ 25, [simData.Graph, simData.FastSim])), delay(() => append_1(singleton_1(new Msg(/* IncrementSimulationClockTick */ 27, [reached - simData.ClockTickNumber])), delay(() => append_1(singleton_1(Msg.ClosePopup), delay(() => ((reached < clock_1) ? append_1(singleton_1(new Msg(/* SetPopupProgress */ 70, [new PopupProgress(reached - initClock, steps, "running simulation...", speed)])), delay(() => singleton_1(new Msg(/* SimulateWithProgressBar */ 72, [new SimulationProgress(initClock, clock_1)])))) : empty_1())))))))))))]));
        });
    }
}

export function viewSimulationData(step, simData, model, dispatch) {
    let props_12, children_12, props_14, children_14, props_10, children_10, stateful, remoteRams, children_8;
    const viewerWidthList = map((tupledArg) => (tupledArg[1] | 0), viewerValues(model, simData));
    const hasMultiBitOutputs = !isEmpty(map((y) => (1 > y), append(map((tupledArg_1) => (tupledArg_1[2] | 0), simData.Outputs), viewerWidthList)));
    const maybeBaseSelector = hasMultiBitOutputs ? baseSelector(simData.NumberBase, (numBase) => {
        changeBase(dispatch, numBase);
    }) : react_1.createElement("div", {});
    let maybeClockTickBtn;
    if (simData.IsSynchronous) {
        const children_4 = [button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* Disabled */ 16, [simData.ClockTickNumber === 0]), new Option(/* OnClick */ 18, [(_arg_4) => {
            advanceTo(model, simData, simData.ClockTickNumber - 1, dispatch, (_arg_5) => {
                dispatch(new Msg(/* SetSimulationGraph */ 25, [simData.Graph, simData.FastSim]));
                dispatch(new Msg(/* IncrementSimulationClockTick */ 27, [-1]));
            });
        }])]), singleton("◀")), " ", " ", button(ofArray([new Option(/* Props */ 17, [singleton(dataTooltip("Click to goto"))]), new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_6) => {
            dialogPopup("Advance Simulation", (model$0027_1) => simulationClockChangePopup(simData, dispatch, model$0027_1), "Goto Tick", (model$0027_2) => {
                simulationClockChangeAction(dispatch, simData, model$0027_2);
            }, (model$0027) => {
                const matchValue_1 = model$0027.PopupDialogData.Int;
                if (matchValue_1 == null) {
                    return true;
                }
                else {
                    return matchValue_1 < 0;
                }
            }, empty(), dispatch);
        }])]), singleton(toText(printf("Clock Tick %d"))(simData.ClockTickNumber))), " ", " ", button(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* OnClick */ 18, [(_arg_7) => {
            advanceTo(model, simData, simData.ClockTickNumber + 1, dispatch, (_arg_8) => {
                dispatch(new Msg(/* SetSimulationGraph */ 25, [simData.Graph, simData.FastSim]));
                dispatch(new Msg(/* IncrementSimulationClockTick */ 27, [1]));
            });
        }])]), singleton("▶"))];
        maybeClockTickBtn = react_1.createElement("div", {}, ...children_4);
    }
    else {
        maybeClockTickBtn = react_1.createElement("div", {});
    }
    const props_16 = [["style", {
        flex: "1 1 auto",
        minHeight: "0px",
        display: "flex",
        flexDirection: "column",
    }]];
    const children_16 = [(props_12 = [["style", {
        flex: "0 0 auto",
    }]], (children_12 = [splittedLine(maybeBaseSelector, maybeClockTickBtn)], react_1.createElement("div", keyValueList(props_12, 1), ...children_12))), (props_14 = [["style", {
        flex: "1 1 auto",
        minHeight: "0px",
        overflowY: "auto",
    }]], (children_14 = [h5(singleton(new Option_2(/* Props */ 9, [singleton(["style", {
        marginTop: "15px",
    }])])))(singleton("Inputs")), viewSimulationInputs(simData.NumberBase, model, simData, ioValues(model, simData, simData.Inputs), dispatch), h5(singleton(new Option_2(/* Props */ 9, [singleton(["style", {
        marginTop: "15px",
    }])])))(ofArray(["Outputs &", (props_10 = [new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " ", "has-tooltip-multiline")]), dataTooltip("Add Viewer components to any sheet in the simulation")], (children_10 = [Text_span(ofArray([new Common_GenericOption(/* Modifiers */ 2, [singleton(new Modifier_IModifier(/* TextColor */ 1, [Color_IColor.IsPrimary]))]), new Common_GenericOption(/* Props */ 1, [singleton(["style", {
        display: "inline-block",
        width: "80px",
        textAlign: "center",
    }])])]), singleton("Viewers"))], react_1.createElement("span", keyValueList(props_10, 1), ...children_10)))])), viewViewers(simData.NumberBase, sort(viewerValues(model, simData), {
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    })), viewSimulationOutputs(simData.NumberBase, ioValues(model, simData, simData.Outputs)), (stateful = ofArray(statefulValues(model, simData)), (remoteRams = (model.SimulateInRenderer ? empty() : map((ram) => splittedLine(concat("RAM: ", ram.Label), button(ofArray([new Option(/* Props */ 17, [singleton(simulationBitStyle)]), new Option(/* Color */ 0, [Color_IColor.IsPrimary]), new Option(/* OnClick */ 18, [(_arg_9) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, _arg_10) => {
            openRemoteRamDiff(ram, simData.ClockTickNumber, model_1, dispatch);
        }, dispatch]));
    }])]), singleton("View"))), ramComponents(simData))), (isEmpty(stateful) && isEmpty(remoteRams)) ? react_1.createElement("div", {}) : ((children_8 = toList(delay(() => append_1(singleton_1(h5(singleton(new Option_2(/* Props */ 9, [singleton(["style", {
        marginTop: "15px",
    }])])))(singleton("Stateful components"))), delay(() => append_1(singleton_1(viewStatefulComponents(step, stateful, simData.NumberBase, model, dispatch)), delay(() => remoteRams)))))), react_1.createElement("div", {}, ...children_8)))))], react_1.createElement("div", keyValueList(props_14, 1), ...children_14)))];
    return react_1.createElement("div", keyValueList(props_16, 1), ...children_16);
}

export function tryGetSimData(isWaveSim, canvasState_, canvasState__1, model) {
    const canvasState = [canvasState_, canvasState__1];
    const model_1 = updateAllMemoryComps(model);
    simCache(simCacheInit());
    const matchValue = rendererStepArraySize(model_1);
    if (matchValue.tag === 0) {
        const _arg = simulateModel(model_1.SimulateInRenderer, isWaveSim, undefined, matchValue.fields[0], canvasState[0], canvasState[1], model_1);
        const copyOfStruct = _arg[0];
        if (copyOfStruct.tag === 1) {
            dbg(32, `simulation error: ${copyOfStruct.fields[0].ErrType}`);
            return new FSharpResult$2(/* Error */ 1, [copyOfStruct.fields[0]]);
        }
        else {
            if (copyOfStruct.fields[0].FastSim.ClockTick === 0) {
                setFastSimInputsToDefault(copyOfStruct.fields[0].FastSim);
            }
            return new FSharpResult$2(/* Ok */ 0, [copyOfStruct.fields[0]]);
        }
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]]);
    }
}

/**
 * Issue the .NET build a step simulation needs: the START's operation - StartSimulation and
 * the goto's cascade both come here, and nothing else ever builds for the step simulator. Its
 * completion (AnsBuilt) creates the session the reads and runs require.
 */
export function issueStepBuild(model, simData) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const top = FastSimulation__get_SimulatedTopSheet(simData.FastSim);
        const design = designForSidecar(simData.FastSim);
        const arraySize = Result_DefaultValue(Constants_maxArraySize, stepSimArraySize(model)) | 0;
        const seq = newSeq();
        const build = Cmd_OfPromise_either(() => build_1(design, arraySize), undefined, (result_1) => (new Msg(/* SidecarReply */ 31, [seq, new SidecarAnswer(/* AnsBuilt */ 0, [result_1])])), (exn) => (new Msg(/* SidecarReply */ 31, [seq, new SidecarAnswer(/* AnsBuilt */ 0, [new FSharpResult$2(/* Error */ 1, [transportFailure(exn.message)])])])));
        return [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, sidecarInFlight_)((table) => add(seq, new SidecarOp(/* OpBuild */ 0, [top, arraySize]), table))(model), build];
    }
    else {
        return [model, Cmd_none()];
    }
}

/**
 * One step of the step-simulation run's cascade: issue the next piece of sidecar work the run
 * needs, or finish, or - if the wire is held by something else - do nothing.
 * 
 * The sequencing is Elmish and nothing else. The cascade is STARTED by a command (StartStepRun);
 * every completion comes back as a message whose handler records the fact and calls this to
 * issue the next chunk - so the set of places the run can continue from is exactly the reply
 * handlers (AnsSteppedTo, AnsBuilt, and AnsFetched for a panel read that borrowed the wire),
 * never "after every message". Cancelling is clearing StepRunTarget - closing the bar does it -
 * and the next completion finds nothing to issue, which is the cancellation's response.
 * 
 * The renderer's own simulator never comes through here: its chunks are synchronous and
 * message-sequenced (SimulateWithProgressBar), so nothing can interleave with them.
 */
export function continueStepRun(model) {
    const matchValue = model.StepRunTarget;
    const matchValue_2 = model.CurrentStepSimulationStep;
    let matchResult, prog_1, simData_1;
    if (matchValue != null) {
        if (model.PopupDialogData.Progress != null) {
            if (matchValue_2 != null) {
                const copyOfStruct = matchValue_2;
                if (copyOfStruct.tag === 0) {
                    if (!model.SimulateInRenderer) {
                        matchResult = 0;
                        prog_1 = matchValue;
                        simData_1 = copyOfStruct.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            if (simData_1.ClockTickNumber >= prog_1.FinalClock) {
                return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, stepRunTarget_)(undefined)(model), singleton((dispatch) => {
                    dispatch(new Msg(/* SetPopupProgress */ 70, [undefined]));
                })];
            }
            else if (!isEmpty_1(model.SidecarInFlight)) {
                return [model, Cmd_none()];
            }
            else {
                const matchValue_4 = SidecarSessionState__get_Epoch(model.SidecarSession);
                if (matchValue_4 == null) {
                    if (model.CurrentProj == null) {
                        return [model, Cmd_none()];
                    }
                    else {
                        return issueStepBuild(model, simData_1);
                    }
                }
                else {
                    const epoch = matchValue_4 | 0;
                    const seq = newSeq();
                    const before = simData_1.ClockTickNumber | 0;
                    const t1 = getTimeMs();
                    const chunk = Cmd_OfPromise_either(() => runChunk(epoch, prog_1.FinalClock), undefined, (result) => (new Msg(/* SidecarReply */ 31, [seq, new SidecarAnswer(/* AnsSteppedTo */ 4, [before, t1, result])])), (exn) => (new Msg(/* SidecarReply */ 31, [seq, new SidecarAnswer(/* AnsSteppedTo */ 4, [before, t1, new FSharpResult$2(/* Error */ 1, [transportFailure(exn.message)])])])));
                    return [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, sidecarInFlight_)((table) => add(seq, new SidecarOp(/* OpStep */ 3, [prog_1.FinalClock]), table))(model), chunk];
                }
            }
        default:
            return [model, Cmd_none()];
    }
}

